import { EntityTemplateVariables } from '@tools/interfaces/template';
import { getActivityFieldsForEntity } from '@tools/config/template-activity';
import { getActivityGroupFieldsForEntity } from '@tools/config/template-activity-group';
import { getContactFieldsForEntity } from '@tools/config/template-contact';
import { templateOrder, templateOrderItem } from '@tools/config/template-order-and-order-items';
import { getUnpaidInvoiceFieldsForEntity } from './template-invoice';

export const templateEnrollment: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.enrollments.code.label',
      contentValue: '{{ enrollment.code }}',
      description: 'templates.enrollments.code.description',
    },
    {
      label: 'templates.enrollments.ordering.label',
      contentValue: '{{ enrollment.ordering }}',
      description: 'templates.enrollments.ordering.description',
    },
    {
      label: 'templates.enrollments.date.label',
      contentValue: '{{ enrollment.date | date("d/m/Y") }}',
      description: 'templates.enrollments.date.description',
    },
    {
      label: 'templates.enrollments.status.label',
      contentValue: '{{ enrollment.status }}',
      description: 'templates.enrollments.status.description',
    },
    {
      label: 'templates.enrollments.comment.label',
      contentValue: '{{ enrollment.comment }}',
      description: 'templates.enrollments.comment.description',
    },
    {
      label: 'templates.enrollments.cancel_reason.label',
      contentValue: '{{ enrollment.cancel_reason }}',
      description: 'templates.enrollments.cancel_reason.description',
    },
    {
      label: 'templates.enrollments.cancel_reason_description.label',
      contentValue: '{{ enrollment.cancel_reason_description }}',
      description: 'templates.enrollments.cancel_reason_description.description',
    },
    {
      label: 'templates.enrollments.answer_1.label',
      contentValue: '{{ enrollment.answer_1 }}',
      description: 'templates.enrollments.answer_1.description',
    },
    {
      label: 'templates.enrollments.answer_2.label',
      contentValue: '{{ enrollment.answer_2 }}',
      description: 'templates.enrollments.answer_2.description',
    },
    {
      label: 'templates.enrollments.answer_3.label',
      contentValue: '{{ enrollment.answer_3 }}',
      description: 'templates.enrollments.answer_3.description',
    },
    {
      label: 'templates.enrollments.answer_4.label',
      contentValue: '{{ enrollment.answer_4 }}',
      description: 'templates.enrollments.answer_4.description',
    },
    {
      label: 'templates.enrollments.answer_5.label',
      contentValue: '{{ enrollment.answer_5 }}',
      description: 'templates.enrollments.answer_5.description',
    },
    {
      label: 'templates.enrollments.price.label',
      contentValue:
        "{{ enrollment.enrollment_price | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
      description: 'templates.enrollments.price.description',
    },
    {
      label: 'templates.enrollments.paid_amount.label',
      contentValue:
        "{{ enrollment.paid_amount | format_currency('EUR', {decimal_always_shown: true, fraction_digit: 2}, locale='fr') }}",
      description: 'templates.enrollments.paid_amount.description',
    },
    {
      label: 'templates.enrollments.last_payment_date.label',
      contentValue: '{{ enrollment.last_payment_date | date("d/m/Y") }}',
      description: 'templates.enrollments.last_payment_date.description',
    },
  ],
  related: [
    {
      relationName: 'bpcActivity',
      relationType: 'simple',
      label: 'templates.enrollments.activity.label',
      description: 'templates.enrollments.activity.description',
      fields: getActivityFieldsForEntity('enrollment.'),
    },
    {
      relationName: 'activityGroup',
      relationType: 'simple',
      label: 'templates.enrollments.activity_group.label',
      description: 'templates.enrollments.activity_group.description',
      fields: getActivityGroupFieldsForEntity('enrollment.'),
    },
    {
      relationName: 'contact',
      relationType: 'simple',
      label: 'templates.enrollments.contact.label',
      description: 'templates.enrollments.contact.description',
      fields: getContactFieldsForEntity('enrollment.'),
    },
    {
      relationName: 'templateHelper',
      relationType: 'simple',
      label: 'templates.products.pending_invoice.label',
      description: 'templates.products.pending_invoice.description',
      fields: getUnpaidInvoiceFieldsForEntity('enrollment'),
    },
  ],
  relatedInLoop: [
    {
      relationName: 'orders',
      relationType: 'inLoop',
      label: 'templates.enrollments.orders.label',
      description: 'templates.enrollments.orders.description',
      blockStartValue: '{% for order in enrollment.orders %}',
      contentValue: '{# Add some order fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateOrder.fields,
    },
    {
      relationName: 'orderItems',
      relationType: 'inLoop',
      label: 'templates.enrollments.order_items.label',
      description: 'templates.enrollments.order_items.description',
      blockStartValue:
        '{% for order in enrollment.orders %}\n{% for orderItem in order.orderItems %}',
      contentValue: '{# Add some orderItem fields #}',
      blockEndValue: '{% endfor %}\n{% endfor %}',
      fields: templateOrderItem.fields,
    },
  ],
};
